import { Button, SemanticUI } from '@iterable/deprecated_react_components';
import {
  segmentLabels,
  segmentSubTopLabels,
  segmentTopLabels,
} from 'modules/queryBuilder/legacyQueryBuilder/utils/combinators';
import {
  StyledCoreButtonGroup,
  AddGroupCoreButton,
  ButtonLabel,
  MainContainer,
  ConnectorLabel,
  ConnectorLabelText,
  GroupConnectorLabel,
  MainTopConnectorLabel,
  MainNotTopConnectorLabel,
} from './SegmentConnector.styled';

// type Props = {
//   /** Additional classes. */
//   className: string,
//   /** Hides the connector lines. */
//   hideConnectorLines: boolean,
//   /** If the connector is a button to add new connector. */
//   isAddButton: boolean,
//   /** If connector is main query connector. */
//   isMainConnector: boolean,
//   /** If the connector is a group connector. */
//   isGroupConnector: boolean,
//   /** If the connector is the last connector of a group. */
//   isLastConnector: boolean,
//   /** If query builder is in read only mode. */
//   isReadOnly?: boolean,
//   /** If the connector is a sub group connector. */
//   isSubGroupConnector: boolean,
//   /** If the connector is the first connector of a group. */
//   isTopConnector: boolean,
//   /** Callback function when connector is clicked if it's an add button. */
//   onClick: () => {},
//   /** Callback function to run when add group button is clicked. */
//   onClickAddGroup: () => {},
//   /** Show the add group button. */
//   showAddGroupButton: boolean,
//   /** Always show label. */
//   showLabel: true,
//   /** Combinator value of the connector. */
//   value: string,
// };

const SegmentConnector = ({
  className,
  hideConnectorLines,
  isAddButton = false,
  isGroupConnector,
  isLastConnector,
  isMainConnector,
  isSubGroupConnector,
  isReadOnly = false,
  isTopConnector,
  onClick,
  onClickAddGroup,
  showAddGroupButton,
  showLabel,
  value,
}) => {
  let label = segmentLabels[value];
  if (isTopConnector) {
    label = isSubGroupConnector ? segmentSubTopLabels[value] : segmentTopLabels[value];
  }

  if (isAddButton) {
    return (
      <StyledCoreButtonGroup className={className} data-role="connector">
        <Button disabled={isReadOnly} onClick={onClick} table>
          <SemanticUI.Icon name="plus" />
          <ButtonLabel>{label}</ButtonLabel>
        </Button>
        {showAddGroupButton && (
          <AddGroupCoreButton disabled={isReadOnly} onClick={onClickAddGroup} table>
            <ButtonLabel>Add a group</ButtonLabel>
          </AddGroupCoreButton>
        )}
      </StyledCoreButtonGroup>
    );
  }

  let ConnectorLabelComponent = ConnectorLabel;
  if (isGroupConnector) {
    ConnectorLabelComponent = GroupConnectorLabel;
  } else if (isMainConnector && isTopConnector) {
    ConnectorLabelComponent = MainTopConnectorLabel;
  } else if (isMainConnector) {
    ConnectorLabelComponent = MainNotTopConnectorLabel;
  }

  return (
    <MainContainer data-role="connector">
      <ConnectorLabelComponent
        hideConnectorLines={hideConnectorLines}
        isOrConnector={value === 'Or'}
        isAndConnector={value === 'And'}
        isNoneConnector={value === 'Not'}
        isGroupConnector={isGroupConnector}
        isMainConnector={isMainConnector}
        isTopConnector={isTopConnector}
        isLastConnector={isLastConnector}
        showLabel={showLabel}
        data-role="label"
      >
        <ConnectorLabelText
          data-value={label}
          isAndConnector={value === 'And'}
          isMainConnector={isMainConnector}
          isNoneConnector={value === 'Not'}
          isOrConnector={value === 'Or'}
          isTopConnector={isTopConnector}
          showLabel={showLabel}
        >
          {label}
        </ConnectorLabelText>
      </ConnectorLabelComponent>
    </MainContainer>
  );
};

export default SegmentConnector;
